import React, { useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Stack, Typography } from '@mui/material'
import { Button } from '@center/ui-kit'

import { downloadBase64 } from 'utils'

import { OPERATION_EXPORT_RAN_ROOMS } from '../operations-gql/queries'
import Modal, { Title, IconTitle } from '../components/Modal'
import { useQueryVariables } from '../store'
import moment from 'moment/moment'
import { trackEvent } from 'analytics'

const Export = () => {
  const { siteId } = useParams()
  const [format, setFormat] = useState(null)
  const [launchExport, { loading, error }] = useLazyQuery(
    OPERATION_EXPORT_RAN_ROOMS,
    {
      variables: { sf_id: siteId },
    },
  )
  const { t } = useTranslation()
  const navigate = useNavigate()
  const queryVariables = useQueryVariables()
  const { i18n } = useTranslation()
  const handleExport = async (format) => {
    setFormat(format)
    trackEvent('private_wifi_export', {
      action_scope: 'page',
      format,
    })
    const {
      data: { base64 },
    } = await launchExport({
      variables: {
        ...queryVariables,
        format,
        language: i18n.language
      },
    })
    await downloadBase64({ base64, fileName: `rans_${moment().format('YYYY/MM/DD')}.${format}` })
    setFormat(null)
  }
  return (
    <Modal onClose={() => navigate('..')}>
      <IconTitle variant={'primary'} icon={'arrow-down-to-line'} />
      <Title>{t('ran.export.title')}</Title>
      {Boolean(error) && <Typography color={'error'}>{t('ran.actions.error')}</Typography>}
      <Box display="flex" alignSelf="center" mt={3} gap={8}>
        <Stack direction={'row'} justifyContent={'space-between'} gap={5}>
          <Button
            disabled={loading && format === 'pdf'}
            size={'small'}
            variant={'contained'}
            color={'primary'}
            onClick={() => handleExport('pdf')}
          >
            <i className={'fa-regular fa-file-pdf'} style={{marginRight: 4}}/>
            {loading && format === 'pdf' ? t('ui_elements.in_progress') : t('ran.export.pdf')}
          </Button>
          <Button
            disabled={loading && format === 'csv'}
            size={'small'}
            variant={'contained'}
            color={'primary'}
            onClick={() => handleExport('csv')}>
            <i className={'fa-regular fa-file-csv'} style={{marginRight: 4}}/>
            {loading && format === 'csv' ? t('ui_elements.in_progress') : t('ran.export.csv')}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default Export
